// Phase 1A Step 34 — Multi-Market Dashboard mock.
// Verbatim port from handoff/landing-reference/expansion.jsx MultiMarketDashboard.
// Single-row component (MultiMarketChainRow) extracted for LOC ceiling.

import { CHAIN_MOCKS } from "./landing-data.ts";
import { MultiMarketChainRow } from "./MultiMarketChainRow.tsx";

export function MultiMarketDashboard(): JSX.Element {
  return (
    <section
      className="sz-l-section"
      style={{
        padding: "160px 0",
        borderTop: "1px solid var(--border)",
      }}
    >
      <div className="container">
        <div
          className="sz-l-section-header"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.6fr",
            gap: 80,
            marginBottom: 60,
          }}
        >
          <div>
            <span className="bracket">Platform · C</span>
          </div>
          <div>
            <h2
              className="serif"
              style={{
                fontSize: "clamp(40px, 5vw, 68px)",
                fontWeight: 500,
                lineHeight: 1.02,
                color: "var(--text)",
                marginBottom: 22,
                letterSpacing: "-0.01em",
              }}
            >
              One dashboard.
              <br />
              <em style={{ color: "var(--accent)", fontStyle: "italic" }}>Every chain.</em>
            </h2>
            <p
              style={{
                fontSize: 17,
                color: "var(--text-muted)",
                maxWidth: 640,
                lineHeight: 1.55,
              }}
            >
              The same engine runs every pipeline. Daily slips, POWERBALL 10, MEGA POWERBALL 20,
              LADDER climbers, the 7-day Singles Chain, Owl Hour late-night — every cycle visible,
              every cost tracked, every settlement sealed in the Daily Intelligence Ledger.
            </p>
          </div>
        </div>

        {/* Mock dashboard */}
        <div className="sz-l-mm-wrap">
          <div
            className="sz-l-mm-dashboard"
            style={{
              background: "var(--surface)",
              border: "1px solid var(--border)",
              overflow: "hidden",
            }}
          >
            {/* Top strip — total portfolio */}
            <div
              className="sz-l-mm-header"
              style={{
                padding: "24px 32px",
                borderBottom: "1px solid var(--border)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "linear-gradient(90deg, rgba(212, 168, 67, 0.06) 0%, transparent 100%)",
              }}
            >
              <div>
                <div className="eyebrow-muted" style={{ marginBottom: 6 }}>
                  Active chains · Mock view
                </div>
                <div
                  className="display"
                  style={{
                    fontSize: 36,
                    color: "var(--text)",
                    letterSpacing: "0.01em",
                  }}
                >
                  Portfolio <span style={{ color: "var(--accent)" }}>·</span> 6 pipelines live
                </div>
              </div>
              <div
                className="mono"
                style={{
                  fontSize: 10,
                  letterSpacing: "0.18em",
                  color: "var(--success)",
                  textTransform: "uppercase",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <span className="live-dot" />
                Real-time sync
              </div>
            </div>

            {/* Chain rows */}
            {CHAIN_MOCKS.map((c, i) => (
              <MultiMarketChainRow key={c.code} c={c} showBorder={i < CHAIN_MOCKS.length - 1} />
            ))}
          </div>
        </div>

        <p
          className="mono"
          style={{
            fontSize: 11,
            color: "var(--text-dim)",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            marginTop: 24,
            textAlign: "right",
          }}
        >
          / Mock dashboard · the six doctrinal pipelines running concurrently on one engine.
        </p>
      </div>
    </section>
  );
}
